import { render, staticRenderFns } from "./InvoiceEdit.vue?vue&type=template&id=68e70fb8&scoped=true"
import script from "./InvoiceEdit.vue?vue&type=script&lang=js"
export * from "./InvoiceEdit.vue?vue&type=script&lang=js"
import style0 from "./InvoiceEdit.vue?vue&type=style&index=0&id=68e70fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e70fb8",
  null
  
)

export default component.exports